enum LogLevel {
  ERROR = 10,
  WARN = 20,
  INFO = 30,
  DEBUG = 40,
  TRACE = 50,
}

const STATE = {
  enabled: false,
  level: __DEV__ ? LogLevel.TRACE : LogLevel.INFO,
}

/**
 * Enable logging to the console. The level to log at defaults to INFO but this
 * can be overridden by setting the local storage key '@@loaded/logLevel' to a
 * string representing the level to log at. The string can be a name of the
 * level or a number representing the level.
 * @example
 * localStorage.setItem('@@loaded/logLevel', 'info')
 * localStorage.setItem('@@loaded/logLevel', 'debug')
 * localStorage.setItem('@@loaded/logLevel', '20')
 * localStorage.setItem('@@loaded/logLevel', '100')
 */
function enable() {
  STATE.enabled = true

  const userLogLevel = localStorage.getItem('@@loaded/logLevel')
  if (!userLogLevel) return

  const nameToLevel: Record<string, LogLevel> = {
    error: LogLevel.ERROR,
    warn: LogLevel.WARN,
    info: LogLevel.INFO,
    debug: LogLevel.DEBUG,
    trace: LogLevel.TRACE,
  }

  const matchedLevel = nameToLevel[userLogLevel.toLowerCase()]
  if (matchedLevel !== undefined) {
    STATE.level = matchedLevel
  } else {
    const numeric = Number(userLogLevel)
    if (!Number.isNaN(numeric)) {
      STATE.level = numeric
    }
  }
}

function debug(...args) {
  STATE.enabled && STATE.level >= LogLevel.DEBUG && console.debug(...args)
}
function error(...args) {
  STATE.enabled && STATE.level >= LogLevel.ERROR && console.error(...args)
}
function info(...args) {
  STATE.enabled && STATE.level >= LogLevel.INFO && console.info(...args)
}
function trace(...args) {
  STATE.enabled && STATE.level >= LogLevel.TRACE && console.trace(...args)
}
function warn(...args) {
  STATE.enabled && STATE.level >= LogLevel.WARN && console.warn(...args)
}

export default {
  enable,
  debug,
  error,
  info,
  trace,
  warn,
}
